module.exports = __webpack_public_path__ + "img/cxTrends-8.bdb3837b.png";